package pl.decks.personal.pages.ievp

import kotlinx.serialization.Serializable
import pl.decks.personal.pages.ievp.foreword.Foreword
import pl.decks.personal.pages.ievp.sections.background.BackgroundEntry
import pl.decks.personal.pages.ievp.sections.experience.ExperienceBreakdownPanel
import pl.decks.personal.pages.ievp.sections.experience.ExperienceEntry
import pl.decks.personal.pages.ievp.sections.profile.ProfileDimension
import pl.decks.personal.pages.ievp.sections.skills.RankingSystem
import pl.decks.personal.pages.ievp.sections.skills.SkillCategory
import pl.decks.posthog.client.PostHogEvent

internal object IEVPJourney {
    @Serializable
    data object JourneyStarted : PostHogEvent("ievp_journey_started")

    @Serializable
    data class SectionReached(val section: IEVPSection) : PostHogEvent("ievp_section_reached")

    @Serializable
    data class SideBarNavigated(val section: IEVPSection) : PostHogEvent("ievp_side_bar_navigated")

    @Serializable
    data class DisclaimerOpened(val section: IEVPSection) : PostHogEvent("ievp_disclaimer_opened")

    @Serializable
    data class CustomForewordPresented(val foreword: Foreword) : PostHogEvent("ievp_custom_foreword_presented")

    @Serializable
    data object ExplanationSkipped : PostHogEvent("ievp_explanation_skipped")

    @Serializable
    data object PitchPlayed : PostHogEvent("ievp_pitch_played")

    @Serializable
    data class RankingSystemSwitched(val system: RankingSystem) : PostHogEvent("ievp_ranking_system_switched")

    @Serializable
    data object RankingPreviewed : PostHogEvent("ievp_ranking_previewed")

    @Serializable
    data class SkillCategoryPresented(val dimension: ProfileDimension, val category: SkillCategory) : PostHogEvent("ievp_skill_category_presented")

    @Serializable
    data class BackgroundCompleted(val background: BackgroundEntry) : PostHogEvent("ievp_background_completed")

    @Serializable
    data class ExperiencePanelPresented(val experience: ExperienceEntry, val panel: ExperienceBreakdownPanel) : PostHogEvent("ievp_experience_panel_presented")

    @Serializable
    data class JourneySummaryRequested(val journeyRandomID: String) : PostHogEvent("ievp_journey_summary_requested")
}
